import React, { ReactNode, useMemo } from 'react';

interface Props {
  count?: number;
  children: ReactNode;
}

export default function FormRow({ count = 1, children }: Props) {
  const classNames = useMemo(() => {
    let output = 'inline-grid gap-2 grid-cols-1';
    if (count > 1) output += ' sm:grid-cols-2';
    if (count > 2) output += ' sm:grid-cols-3';
    return output;
  }, [count]);

  return <div className={classNames}>{children}</div>;
}
